import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class PersonalizedOfferService {
    static getOfferDataFromServer(currentPath, params, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('personalizedOffer'),
            'getPersonalizedOffer',
            [currentPath, params],
            additionalHeaders
        );
    }
}
